import { dataSync } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSync = /*#__PURE__*/createIcon(dataSync)
export default IconSync
